<template>
    <mdb-card class="search-card mb-2 deparFly"
              :class="{flySelect:selected == index, hide:(ucusTipiF(fromSearch.segments.length>1?2:1)===false && ucusTipi.length>0) || (saatFiltre === true &&
                              ((parseInt(gidisKalkis[0])>=parseInt(fromSearch.segments[0].departure_time.split(':')[0]))
                              || (parseInt(gidisKalkis[1])<=parseInt(fromSearch.segments[0].departure_time.split(':')[0]))
                              || (parseInt(gidisVaris[0])>=parseInt(fromSearch.segments.length>1?fromSearch.segments[1].arrival_time.split(':')[0]:fromSearch.segments[0].arrival_time.split(':')[0])
                              || (parseInt(gidisVaris[1])<parseInt(fromSearch.segments.length>1?fromSearch.segments[1].arrival_time.split(':')[0]:fromSearch.segments[0].arrival_time.split(':')[0])))))}" :id="'depar_fly'+index"
              v-if="(fromSearch.option_flag == 'OW' || fromSearch.option_flag == 'OUT') && (selected == index || selected==undefined) ">
        <mdb-card-body>
            <div class="row px-2">
                <div class="col-12 col-lg-9">
                    <div class="row">
                        <p class="flight-info col-12 p-0 mb-1">{{fromSearch.segments[0].marketing_airline_name?fromSearch.segments[0].marketing_airline_name:fromSearch.segments[0].operating_airline_name}}{{fromSearch.segments[1]?" - "+fromSearch.segments[1].marketing_airline_name:""}}</p>
                        <div class="col-1 pr-0 d-none d-md-block">
                            <mdb-icon icon="plane-departure"  />
                        </div>
                        <div class="col-6 col-md-4 pl-0">
                            <span class="hour"> {{fromSearch.segments[0].departure_time.split(":")[0]}}:{{fromSearch.segments[0].departure_time.split(":")[1]?fromSearch.segments[0].departure_time.split(":")[1]:'00'}} </span>
                            <span class="airport-name" :data-tooltip="fromName"> {{fromSearch.segments[0].od_origin_code}} </span>
                            <span class="airport-city d-none d-sm-inline-block"> {{fromCity}} </span>
                        </div>
                        <div class="col-6 col-md-4 pl-0">
                                            <span class="hour"> {{fromSearch.segments.length>1?
                                                fromSearch.segments[1].arrival_time.split(":")[0]+':'+(fromSearch.segments[1].arrival_time.split(":")[1]?
                                                fromSearch.segments[1].arrival_time.split(":")[1]:'00'):
                                                fromSearch.segments[0].arrival_time.split(":")[0]+':'+(fromSearch.segments[0].arrival_time.split(":")[1]?
                                                fromSearch.segments[0].arrival_time.split(":")[1]:
                                                '00')}} </span>
                            <span class="airport-name" :data-tooltip="toName"> {{fromSearch.segments.length>1?fromSearch.segments[1].od_destination_code:fromSearch.segments[0].od_destination_code}} </span>
                            <span class="airport-city d-none d-sm-inline-block"> {{toCity}} </span>
                        </div>
                        <div class="col-12 col-sm-4 col-md-3 p-0 my-2 my-md-0 mb-md-2">
                            <span class="flight-type-icon"><mdb-icon icon="clock" /></span>
                            <span class="flight-time"> {{fromSearch.duration.split(":")[0]}}h {{fromSearch.duration.split(":")[1]}}m</span>
                            <span class="flight-type"> {{fromSearch.segments.length>1?"Aktarmalı":"Direkt"}} </span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-12 col-lg-2 p-0">
                    <mdb-btn color="red-price" class="m-0 px-1 btn-block">{{fromSearch.total_fare}}₺</mdb-btn>
                    <mdb-btn v-if="!fromSearch.alternative_prices.T_AlternativePrice || !fromSearch.alternative_prices.T_AlternativePrice.length || flightClass === 'Business'" color="middle-blue" class="m-0 px-1 btn-block btn-blue-sec" :data-depar="index" @click="selected = index, setCommission(fromSearch.total_fare)">Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                    <div class="mt-2">
                    </div>
                </div>
            </div>
            <div class="alt-div text-right">
                <mdb-collapse v-if="(fromSearch.alternative_prices.T_AlternativePrice && fromSearch.alternative_prices.T_AlternativePrice.length >= 3) && flightClass !== 'Business'" :toggleTag="['a']" :togglers="1" :toggleClass="['btn-mobile-block btn-blue-sec btn btn-middle-blue alternative-btn']" :toggleText="['Uçuş Seç']">
                    <div class="col-12 px-1 text-left">
                        <div class="row">
                            <div  class="col-12 col-md-4" v-if="fromSearch.alternative_prices.T_AlternativePrice[0]">
                                <div v-if="fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.length>1">
                                    <div v-if="fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem" >
                                        <mdb-card testimonial>
                                            <mdb-card-up  class="lighten-1 text-white ecofly">
                                                <h6 class="text-center">Eco Fly</h6>
                                                <p class="text-center">({{fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].BookingClassCode}} Sınıf)</p>
                                            </mdb-card-up>
                                            <mdb-card-body>
                                                <ul class="list-unstyled">
                                                    <li v-for="baggage in fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].BrandedMinuRules.FreeBaggageAllowance.FBA.PaxBaggageAllowance">
                                                        <mdb-icon icon="angle-double-right" /> {{baggage.PaxFBA?baggage.PaxFBA.Allowance:""}} kg
                                                        <span v-if="baggage.PaxFBA && baggage.PaxFBA.Type==='Weight'">Bagaj hakkı</span>
                                                        <span v-else>El Bagajı</span>
                                                    </li>
                                                    <li><mdb-icon icon="angle-double-right" /> İade edilemez.</li>
                                                    <li><mdb-icon icon="angle-double-right" /> Değiştirilemez.</li>
                                                    <li><mdb-icon icon="angle-double-right" /> İkram</li>
                                                </ul>
                                                <h5 class="text-red text-center price">{{ calcCommission(fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.LastSellerCommission) }} <span class="text-muted">TRY</span></h5>
                                                <mdb-btn v-if="fromSearch.alternative_prices.T_AlternativePrice"
                                                         color="middle-blue"
                                                         class="m-0 px-1 btn-block btn-blue-sec"
                                                         :data-depar="index"
                                                         @click="selected = index, brandclick(fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].BrandedMinuRules.BrandCode,fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.ProductItemId,1, (fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.LastSellerCommission))"
                                                         :data-brndprice="fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.TotalFare"
                                                >Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>

                                                <p class="d-none">{{fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.ProductItemId}}</p>
                                            </mdb-card-body>
                                        </mdb-card>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem" >
                                        <mdb-card testimonial>
                                            <mdb-card-up  class="lighten-1 text-white ecofly">
                                                <h6 class="text-center">Eco Fly</h6>
                                                <p class="text-center">({{fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.BookingClassCode}} Sınıf)</p>
                                            </mdb-card-up>
                                            <mdb-card-body>
                                                <ul class="list-unstyled">
                                                    <li v-for="baggage in fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.BrandedMinuRules.FreeBaggageAllowance.FBA.PaxBaggageAllowance">
                                                        <mdb-icon icon="angle-double-right" /> {{baggage.PaxFBA?baggage.PaxFBA.Allowance:""}} kg
                                                        <span v-if="baggage.PaxFBA && baggage.PaxFBA.Type==='Weight'">Bagaj hakkı</span>
                                                        <span v-else>El Bagajı</span>
                                                    </li>
                                                    <li><mdb-icon icon="angle-double-right" /> İade edilemez.</li>
                                                    <li><mdb-icon icon="angle-double-right" /> Değiştirilemez.</li>
                                                    <li><mdb-icon icon="angle-double-right" /> İkram</li>
                                                </ul>
                                                <h5 class="text-red text-center price">{{ calcCommission(fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.LastSellerCommission) }} <span class="text-muted">TRY</span></h5>
                                                <mdb-btn v-if="fromSearch.alternative_prices.T_AlternativePrice"
                                                         color="middle-blue"
                                                         class="m-0 px-1 btn-block btn-blue-sec"
                                                         :data-depar="index"
                                                         @click="selected = index, brandclick(fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.BrandedMinuRules.BrandCode,fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.ProductItemId,1, (fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.LastSellerCommission))"
                                                         :data-brndprice="fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.TotalFare"
                                                >Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>

                                                <p class="d-none">{{fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.ProductItemId}}</p>
                                            </mdb-card-body>
                                        </mdb-card>
                                    </div>
                                </div>
                            </div>
                            <div  class="col-12 col-md-4" v-if="fromSearch.alternative_prices.T_AlternativePrice[1]">
                                <div v-if="fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.length>1">
                                    <div v-if="fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem" >
                                        <mdb-card testimonial>
                                            <mdb-card-up  class="lighten-1 text-white primefly">
                                                <h6 class="text-center">Extra Fly</h6>
                                                <p class="text-center">({{fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].BookingClassCode}} Sınıf)</p>
                                            </mdb-card-up>
                                            <mdb-card-body>
                                                <ul class="list-unstyled">
                                                    <li v-for="baggage in fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].BrandedMinuRules.FreeBaggageAllowance.FBA.PaxBaggageAllowance">
                                                        <mdb-icon icon="angle-double-right" /> {{baggage.PaxFBA?baggage.PaxFBA.Allowance:""}} kg
                                                        <span v-if="baggage.PaxFBA && baggage.PaxFBA.Type==='Weight'">Bagaj hakkı</span>
                                                        <span v-else>El Bagajı</span>
                                                    </li>
                                                    <li><mdb-icon icon="angle-double-right" /> Ücretsiz koltuk seçimi.</li>
                                                    <li><mdb-icon icon="angle-double-right" /> İkram</li>
                                                    <li><mdb-icon icon="angle-double-right" /> 250 Ekstra Bonus Mil</li>
                                                    <li><mdb-icon icon="angle-double-right" /> Ücretli değişiklik</li>
                                                    <li><mdb-icon icon="angle-double-right" /> Kesintili iade (12 saate kadar)</li>
                                                </ul>
                                                <div class="alternatif-sec">
                                                    <h5 class="text-red text-center price">{{ calcCommission(fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.LastSellerCommission) }} <span class="text-muted">TRY</span></h5>
                                                    <mdb-btn v-if="fromSearch.alternative_prices.T_AlternativePrice"
                                                             color="middle-blue"
                                                             class="m-0 px-1 btn-block btn-blue-sec"
                                                             :data-depar="index"
                                                             @click="selected = index, brandclick(fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].BrandedMinuRules.BrandCode,fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.ProductItemId,1, (fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.LastSellerCommission))"
                                                             :data-brndprice="fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.TotalFare"
                                                    >Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                                                </div>
                                                <p class="d-none">{{fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.ProductItemId}}</p>
                                            </mdb-card-body>
                                        </mdb-card>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem" >
                                        <mdb-card testimonial>
                                            <mdb-card-up  class="lighten-1 text-white primefly">
                                                <h6 class="text-center">Extra Fly</h6>
                                                <p class="text-center">({{fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.BookingClassCode}} Sınıf)</p>
                                            </mdb-card-up>
                                            <mdb-card-body>
                                                <ul class="list-unstyled">
                                                    <li v-for="baggage in fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.BrandedMinuRules.FreeBaggageAllowance.FBA.PaxBaggageAllowance">
                                                        <mdb-icon icon="angle-double-right" /> {{baggage.PaxFBA?baggage.PaxFBA.Allowance:""}} kg
                                                        <span v-if="baggage.PaxFBA && baggage.PaxFBA.Type==='Weight'">Bagaj hakkı</span>
                                                        <span v-else>El Bagajı</span>
                                                    </li>
                                                    <li><mdb-icon icon="angle-double-right" /> Ücretsiz koltuk seçimi.</li>
                                                    <li><mdb-icon icon="angle-double-right" /> İkram</li>
                                                    <li><mdb-icon icon="angle-double-right" /> 250 Ekstra Bonus Mil</li>
                                                    <li><mdb-icon icon="angle-double-right" /> Ücretli değişiklik</li>
                                                    <li><mdb-icon icon="angle-double-right" /> Kesintili iade (12 saate kadar)</li>
                                                </ul>
                                                <div class="alternatif-sec">
                                                    <h5 class="text-red text-center price">{{ calcCommission(fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.LastSellerCommission) }} <span class="text-muted">TRY</span></h5>
                                                    <mdb-btn v-if="fromSearch.alternative_prices.T_AlternativePrice"
                                                             color="middle-blue"
                                                             class="m-0 px-1 btn-block btn-blue-sec"
                                                             :data-depar="index"
                                                             @click="selected = index, brandclick(fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.BrandedMinuRules.BrandCode,fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.ProductItemId,1, (fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.TotalFare))"
                                                             :data-brndprice="fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.TotalFare"
                                                    >Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                                                </div>
                                                <p class="d-none">{{fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.ProductItemId}}</p>
                                            </mdb-card-body>
                                        </mdb-card>
                                    </div>
                                </div>
                            </div>
                            <div  class="col-12 col-md-4" v-if="fromSearch.alternative_prices.T_AlternativePrice[2]">
                                <div v-if="fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.length>1">
                                    <div v-if="fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem" >
                                        <mdb-card testimonial>
                                            <mdb-card-up  class="lighten-1 text-white extrafly">
                                                <h6 class="text-center">Prime Fly</h6>
                                                <p class="text-center">({{fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].BookingClassCode}} Sınıf)</p>
                                            </mdb-card-up>
                                            <mdb-card-body>
                                                <ul class="list-unstyled">
                                                    <li v-for="baggage in fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].BrandedMinuRules.FreeBaggageAllowance.FBA.PaxBaggageAllowance">
                                                        <mdb-icon icon="angle-double-right" /> {{baggage.PaxFBA?baggage.PaxFBA.Allowance:""}} kg
                                                        <span v-if="baggage.PaxFBA && baggage.PaxFBA.Type==='Weight'">Bagaj hakkı</span>
                                                        <span v-else>El Bagajı</span>
                                                    </li>
                                                    <li><mdb-icon icon="angle-double-right" /> Ücretsiz koltuk seçimi.</li>
                                                    <li><mdb-icon icon="angle-double-right" /> İkram</li>
                                                    <li><mdb-icon icon="angle-double-right" /> 500 Ekstra Bonus Mil</li>
                                                    <li><mdb-icon icon="angle-double-right" /> Cezasız değişiklik</li>
                                                    <li><mdb-icon icon="angle-double-right" /> Kesintisiz iade (12 saate kadar)</li>
                                                </ul>
                                                <h5 class="text-red text-center price">{{ calcCommission(fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.LastSellerCommission) }} <span class="text-muted">TRY</span></h5>
                                                <mdb-btn v-if="fromSearch.alternative_prices.T_AlternativePrice"
                                                         color="middle-blue"
                                                         class="m-0 px-1 btn-block btn-blue-sec"
                                                         :data-depar="index"
                                                         @click="selected = index, brandclick(fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].BrandedMinuRules.BrandCode,fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.ProductItemId,1, (fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.LastSellerCommission))"
                                                         :data-brndprice="fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.TotalFare"
                                                >Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                                                <p class="d-none">{{fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.ProductItemId}}</p>
                                            </mdb-card-body>
                                        </mdb-card>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem" >
                                        <mdb-card testimonial>
                                            <mdb-card-up  class="lighten-1 text-white extrafly">
                                                <h6 class="text-center">Prime Fly</h6>
                                                <p class="text-center">({{fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.BookingClassCode}} Sınıf)</p>
                                            </mdb-card-up>
                                            <mdb-card-body>
                                                <ul class="list-unstyled">
                                                    <li v-for="baggage in fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.BrandedMinuRules.FreeBaggageAllowance.FBA.PaxBaggageAllowance">
                                                        <mdb-icon icon="angle-double-right" /> {{baggage.PaxFBA?baggage.PaxFBA.Allowance:""}} kg
                                                        <span v-if="baggage.PaxFBA && baggage.PaxFBA.Type==='Weight'">Bagaj hakkı</span>
                                                        <span v-else>El Bagajı</span>
                                                    </li>
                                                    <li><mdb-icon icon="angle-double-right" /> Ücretsiz koltuk seçimi.</li>
                                                    <li><mdb-icon icon="angle-double-right" /> İkram</li>
                                                    <li><mdb-icon icon="angle-double-right" /> 500 Ekstra Bonus Mil</li>
                                                    <li><mdb-icon icon="angle-double-right" /> Cezasız değişiklik</li>
                                                    <li><mdb-icon icon="angle-double-right" /> Kesintisiz iade (12 saate kadar)</li>
                                                </ul>
                                                <h5 class="text-red text-center price">{{ calcCommission(fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.LastSellerCommission) }} <span class="text-muted">TRY</span></h5>
                                                <mdb-btn v-if="fromSearch.alternative_prices.T_AlternativePrice"
                                                         color="middle-blue"
                                                         class="m-0 px-1 btn-block btn-blue-sec"
                                                         :data-depar="index"
                                                         @click="selected = index, brandclick(fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.BrandedMinuRules.BrandCode,fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.ProductItemId,1, (fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.LastSellerCommission))"
                                                         :data-brndprice="fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.TotalFare"
                                                >Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                                                <p class="d-none">{{fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.ProductItemId}}</p>
                                            </mdb-card-body>
                                        </mdb-card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mdb-collapse>
            </div>
            <div class="h-slide w-100 dt-fl">
                <mdb-collapse :toggleTag="['a']" :togglers="1" :toggleClass="['non-btn detay-fly']" :toggleText="['Uçuş Detaylarını Göster']" >
                    <div  class="mt-2 col-12 p-0">
                        <div class="flight-details text-left">
                            <div class="row" v-for="(aktarma,index) in fromSearch.segments" :key="index" style="border-bottom: 1px solid #e3e3e3">
                                <div class="col-8">
                                    <ul class="pl-2 pl-md-4 pl-lg-4 pl-xl-5">
                                        <li>
                                            <span class="time">{{aktarma.departure_time.split(":")[0]}}:{{aktarma.departure_time.split(":")[1]?aktarma.departure_time.split(":")[1]:"00"}}</span>    {{aktarma.origin_code}} - {{aktarma.origin_name}} Havalimanı
                                        </li>
                                        <li>
                                            <span class="time">{{aktarma.arrival_time.split(":")[0]}}:{{aktarma.arrival_time.split(":")[1]?aktarma.arrival_time.split(":")[1]:"00"}}</span>    {{aktarma.destination_code}} - {{aktarma.destination_name}} Havalimanı
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-4 pr-0">
                                    <ul class="list-unstyled">
                                        <li>Uçuş No: {{aktarma.flight_number}}</li>
                                        <li>Sınıfı: {{aktarma.booking_class}}</li>
                                        <li>Bagaj: {{fromSearch.baggage?fromSearch.baggage.allowance:""}} {{fromSearch.baggage?fromSearch.baggage.type === 'Weight'?"kg":"Parça":""}}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </mdb-collapse>
            </div>
        </mdb-card-body>
    </mdb-card>
</template>

<script>
    import { mdbContainer, mdbCol, mdbRow, mdbIcon, mdbView, mdbBtn, mdbCard, mdbCardHeader,mdbCardUp, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText,mdbCollapse, mdbStretchedLink,} from 'mdbvue';
    import VueSlider from "vue-slider-component";

    export default {
        props:{
          commission: {
            type: Object
          },
          fromSearch: {
              type: Object
          },
            index: {
              type: Number
            },
            clearSelected: {
              type: Boolean,
                default: false
            },
            ucusTipi: {
                type: Array
            },
            flightClass: {
                type: String
            },
            gidisKalkis: {
                type: Array,
                default: [0, 24]
            },
            saatFiltre: {
                type: Boolean,
                default: false
            },
        },
        name: "ListsFlight",
        components:{
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbView,
            mdbBtn,
            mdbCard,
            mdbCardHeader,
            mdbCardUp,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCollapse,
            mdbStretchedLink,
        },
        data() {
            return {
                lazyloadData:[],
                scrollPosition: null,
                testUrl:"flight",
                noFlight:false,
                displayShow:false,

                ucusTipiR:[],
                dateFormat: 'D MMMM YYYY',
                dateFormatDay:'ddd',
                dateFormatSql: 'YYYY-MM-DD',
                collapse: false,
                return2: false,
                show: true,
                flightType:"",
                fromCity:"",
                fromCountry:"",
                fromIsCity:"",
                fromName:"",
                toCity:"",
                toCountry:"",
                toIsCity:"",
                toName:"",
                fromAir :"",
                toAir :"",
                fromDate :"",
                toDate :"",
                adult :"",
                child :"",
                infant :"",
                ecofly:"",
                extrafly:"",
                primefly:"",
                ecoflyR:"",
                extraflyR:"",
                primeflyR:"",
                resultsAir:[],
                resultsCharterDepartureFlight:[],
                resultsCharterReturnFlight:[],
                resultsRecommendAir:[],
                durationHour:"",
                durationMinute:"",
                departureTime:"",
                arrivalTime:"",
                OD_OriginCode:"",
                OD_DestinationCode:"",
                aktarmali :1,
                MarketingAirline:"",
                sessionAll:[],
                recomselected:undefined,
                subindex:undefined,
                subrindex:undefined,
                charterDeparselected:undefined,
                charterReturnselected:undefined,
                selected:undefined,
                toselected:undefined,
                firstAktarma:"",
                window: {
                    width: 0,
                    height: 0
                },
                departure_charter_id:"",
                return_charter_id:"",
                dp_product_id:"",
                dp_product_id_recommend:"",
                departure_branded_code:"",
                departure_product_id:"",
                return_branded_code:"",
                return_product_id:"",
                sub_options:[],
                dp_service_fee:"",
                rt_product_id:"",
                rt_service_fee:"",
                ucusDeparSaatiParcali:[],
                ucusArrivalSaatiParcali:[],
                gidisKalkisSaatK:"",
                gidisKalkisSaatB:"",

                gidisVaris: [0, 24],
                donusKalkis: [0, 24],
                donusVaris: [0, 24],
                birdenFazla:false,
                birAktarma:false,
                direk:false,
                passDay :"",
                nextDay:"",
                passDayTo :"",
                nextDayTo:"",

            }
        },
        watch:{
            selected: function () {
                this.$emit('change',this.selected)
            },
            clearSelected: function () {
                if(this.clearSelected == true){
                    this.selected=undefined
                    this.clearSelected = false
                }
            }
        },
        methods:{

            brandFareType(tip,deger){
                if(tip === "eco"){
                    this.ecofly = "";
                    this.ecofly = deger;
                }
                if(tip === "ext"){
                    this.extrafly = "";
                    this.extrafly = deger;
                }
                if(tip === "prm"){
                    this.primefly = "";
                    this.primefly = deger;
                }
            },
            brandclick(code,id,tur, fare = 0){
                if(tur === 1){
                    this.departure_branded_code = code;
                    this.departure_product_id = id;
                    localStorage.departure_branded_code = this.departure_branded_code;
                    localStorage.departure_product_id = this.departure_product_id;
                    localStorage.departure_commission = (this.commission.type == "percentage" ? parseFloat(fare * this.commission.value / 100) : parseFloat(this.commission.value)).toFixed(2);
                } else {
                    this.return_branded_code = code;
                    this.return_product_id = id;
                    localStorage.return_branded_code = this.return_branded_code;
                    localStorage.return_product_id = this.return_product_id;
                    localStorage.return_commission = (this.commission.type == "percentage" ? parseFloat(fare * this.commission.value / 100) : parseFloat(this.commission.value)).toFixed(2);
                }
            },
            setCommission(fare) {
              localStorage.departure_commission = (this.commission.type == "percentage" ? parseFloat(fare * this.commission.value / 100) : parseFloat(this.commission.value)).toFixed(2);
            },
            calcCommission(fare) {
              return ((this.commission.type == "percentage" ? parseFloat(fare * this.commission.value / 100) : parseFloat(this.commission.value)) + parseFloat(fare)).toFixed(2);
            },
            ucusTipiF(n) {
                return this.ucusTipi.indexOf(n.toString()) > -1
            },
            ucusTipiReturn(n) {
                return this.ucusTipiR.indexOf(n.toString()) > -1
            },
            duration(times){

                let parcaTimes = times.split(":");

                this.durationHour = parcaTimes[0];
                this.durationMinute = parcaTimes[1];
            },
            recomduration(times){

                let parcaReTimes = times.split(":");

                this.durationHour = parcaReTimes[0];
                this.durationMinute = parcaReTimes[1];
            },
            returnFlightControl(fromSearch){
                if(fromSearch.return_flight.length===0){
                    return fromSearch.return_flight = [{bos:'bos'}];
                }
            },
            recomflightTimes(segment){
                if(segment.length>1){
                    this.birAktarma = true;
                    if(segment[0].marketing_airline_name === segment[1].marketing_airline_name){
                        this.MarketingAirline = segment[0].marketing_airline_name;
                    }else{
                        this.MarketingAirline = segment[0].marketing_airline_name +" - "+segment[1].marketing_airline_name;
                    }
                    this.aktarmali = segment.length;
                    this.OD_OriginCode = segment[0].departure_airport_code;
                    this.OD_DestinationCode = segment[1].arrival_airport_code;
                    this.firstAktarma = segment[0].arrival_airport_code;
                    if(segment[0].departure_time){
                        this.ucusDeparSaatiParcali = segment[0].departure_time.split(":");
                        if(this.ucusDeparSaatiParcali[1]){
                            this.departureTime = segment[0].departure_time;
                        }else{
                            this.departureTime = this.ucusDeparSaatiParcali[0] + ":00";
                        }
                        if(segment[1].arrival_time){
                            this.ucusArrivalSaatiParcali = segment[1].arrival_time.split(":");
                            if(this.ucusArrivalSaatiParcali[1]){
                                this.arrivalTime = segment[1].arrival_time;
                            }else{
                                this.arrivalTime = this.ucusArrivalSaatiParcali[0] + ":00";
                            }
                        }
                    }
                }else{
                    if(segment){
                        this.aktarmali = 1;
                        this.direk=true;
                        this.MarketingAirline = segment[0].marketing_airline_name;
                        this.OD_OriginCode = segment[0].departure_airport_code;
                        this.OD_DestinationCode = segment[0].arrival_airport_code;
                        if(segment[0].departure_time){
                            this.ucusDeparSaatiParcali = segment[0].departure_time.split(":");
                            if(this.ucusDeparSaatiParcali[1]){
                                this.departureTime = segment[0].departure_time;
                            }else{
                                this.departureTime = this.ucusDeparSaatiParcali[0] + ":00";
                            }
                            if(segment[0].arrival_time){
                                this.ucusArrivalSaatiParcali = segment[0].arrival_time.split(":");
                                if(this.ucusArrivalSaatiParcali[1]){
                                    this.arrivalTime = segment[0].arrival_time;
                                }else{
                                    this.arrivalTime = this.ucusArrivalSaatiParcali[0] + ":00";
                                }
                            }

                        }

                        /*this.departureTime = segment[0].departure_time;
                        this.arrivalTime = segment[0].arrival_time;*/
                        this.firstAktarma = segment[0].destination_code;
                    }

                }
            },
            flightTimes(segment){
                if(segment.length>1){
                    this.birAktarma = true;
                    /*this.MarketingAirline = segment[0].marketing_airline_name +" - "+segment[1].marketing_airline_name;
                    this.aktarmali = segment.length;
                    this.OD_OriginCode = segment[0].od_origin_code;
                    this.OD_DestinationCode = segment[1].od_destination_code;
                    this.firstAktarma = segment[0].destination_code;*/

                    this.ucusDeparSaatiParcali = segment[0].departure_time.split(":");
                    if(this.ucusDeparSaatiParcali[1]){
                        this.departureTime = segment[0].departure_time;
                    }else{
                        this.departureTime = this.ucusDeparSaatiParcali[0] + ":00";
                    }
                    if(this.ucusDeparSaatiParcali[0]==="00"){
                        this.ucusDeparSaatiParcali[0]=24;
                    }

                    this.ucusArrivalSaatiParcali = segment[1].arrival_time.split(":");
                    if(this.ucusArrivalSaatiParcali[1]){
                        this.arrivalTime = segment[1].arrival_time;
                    }else{
                        this.arrivalTime = this.ucusArrivalSaatiParcali[0] + ":00";
                    }

                    if(this.ucusArrivalSaatiParcali[0]==="00"){
                        this.ucusArrivalSaatiParcali[0]=24;
                    }
                }else{
                    this.aktarmali = 1;
                    this.direk=true;
                    this.MarketingAirline = segment[0].marketing_airline_name;
                    this.OD_OriginCode = segment[0].od_origin_code;
                    this.OD_DestinationCode = segment[0].od_destination_code;
                    this.ucusDeparSaatiParcali = segment[0].departure_time.split(":");
                    if(this.ucusDeparSaatiParcali[1]){
                        this.departureTime = segment[0].departure_time;
                    }else{
                        this.departureTime = this.ucusDeparSaatiParcali[0] + ":00";
                    }
                    if(this.ucusDeparSaatiParcali[0]==="00"){
                        this.ucusDeparSaatiParcali[0]=24;
                    }
                    this.ucusArrivalSaatiParcali = segment[0].arrival_time.split(":");
                    if(this.ucusArrivalSaatiParcali[1]){
                        this.arrivalTime = segment[0].arrival_time;
                    }else{
                        this.arrivalTime = this.ucusArrivalSaatiParcali[0] + ":00";
                    }
                    if(this.ucusArrivalSaatiParcali[0]==="00"){
                        this.ucusArrivalSaatiParcali[0]=24;
                    }
                    this.firstAktarma = segment[0].destination_code;
                }
            },
            formatDates(fromDate, dateTwo,dateType) {
                let formattedDates = '';
                if (fromDate) {
                    formattedDates = format(fromDate, this.dateFormat)
                }
                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat)
                }
                if (dateType){
                    if (dateType == 1){
                        formattedDates = format(fromDate, this.dateFormatDay)
                    }else{
                        formattedDates = format(fromDate, this.dateFormatSql)
                    }
                }
                return formattedDates;
            },
        }
    }
</script>

<style scoped>

</style>
